<h1 class="text-center m-3">Thank you for signing up!</h1>

<div class="row justify-content-center">
<div class="mat-card col-md-4 form-check relative" *ngIf="subscriptionDetails">
<h2 class="m-3">Package: {{subscriptionDetails.amount | currency: 'R'}} per month</h2>
<p>Billing date: {{subscriptionDetails.billing_date}}</p>
<p><fa-icon [icon]="faCheckCircle"></fa-icon>{{paymentConfirmed ? 'Confirmed' : 'Pending confirmation'}}</p>
</div>

</div>
<div class="row justify-content-center mt-3">
    <button class="text-white" routerLink="../dashboard" mat-raised-button color="primary">Continue to my dashboard</button>
</div>
